/* WinBoost site config + lead delivery.
   Fill in the two values below and every form and call CTA on the site is live. */
(() => {
  const CONFIG = {
    /* Where lead submissions are POSTed as JSON. Any webhook that accepts a POST
       works, n8n, Make, Zapier catch hook, or your own endpoint. */
    webhook: '',
    /* The AI Phone number visitors reach when they tap the hero orb or a call CTA.
       Digits and + only, e.g. '+15145550134'. */
    phone: '',
    /* Live demo numbers per industry, so a visitor can hear a real example call for
       their own kind of business. Key = industry icon slug used in sections-proof.jsx.
       Leave a value empty and that tile falls back to CONFIG.phone; if that is empty
       too, the tile shows "Demo line coming soon" instead of a dead link. */
    demoNumbers: {
      medical: '', wrench: '', house: '', scales: '', car: '',
      nail: '', dumbbell: '', finance: '', people: ''
    },
    /* Recorded AI Phone calls per industry. Drop the audio file in
       ui_kits/website/assets/calls/ and put the filename here, e.g. 'medical.mp3'.
       A full URL works too. Leave a value empty and that tile shows
       "Recording coming soon" instead of a dead player. */
    callRecordings: {
      medical: '', wrench: '', house: '', scales: '', car: '',
      nail: '', dumbbell: '', finance: '', people: ''
    }
  };

  (function () {
    var s = window.WB_SHOP_CONFIG;
    if (!s) return;
    if (s.phone) CONFIG.phone = s.phone;
    var r = s.recordings || {};
    for (var k in r) if (r[k]) CONFIG.callRecordings[k] = r[k];
    CONFIG.reviews = s.reviews || [];
    CONFIG.retailerApplyUrl = s.retailerApplyUrl || '';
    CONFIG.consultantUrl = s.consultantUrl || '';
    CONFIG.links = s.links || {};
    CONFIG.shopifyLeads = true;
  })();
  window.WB_URL = function (p) {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/', q = String(p).replace(/^[/]+/, '');
    /* Shopify's own addresses (product.url, routes.*) already start with the language folder, e.g. /fr/products/ai-phone: never add it twice */
    return r !== '/' && ('/' + q + '/').indexOf(r) === 0 ? '/' + q : r + q;
  };
  /* ---- THE LINK MAP: one place decides where every Buy button and footer link goes. The destinations come from the theme
     settings (Customize > Theme settings > Links); this code only falls back to the defaults below when a setting is empty. ---- */
  window.WB_LINKS = function () { return (window.WB_CONFIG && window.WB_CONFIG.links) || {}; };
  /* A destination from the settings (or its default), as a full href. Accepts "/products/x", "products/x" or a whole https:// address. */
  window.WB_DEST = function (key, dflt, qs, hash) {
    var v = String(window.WB_LINKS()[key] || dflt), i = v.indexOf('#');
    if (i > -1) v = v.slice(0, i);
    var url = /^([a-z][a-z0-9+.-]*:|[/][/])/i.test(v) ? v : window.WB_URL(v.replace(/^[/]+/, ''));
    if (qs) url += (url.indexOf('?') > -1 ? '&' : '?') + qs;
    return url + (hash || '');
  };
  /* Every "Buy" button -> the AI Phone product page (ids from the configurator: in, out, orb, sms), never a form. */
  window.WB_BUY_HREF = function (ids, from) {
    ids = ids || [];
    var i = ids.indexOf('in') > -1, o = ids.indexOf('out') > -1;
    var phone = i && o ? 'Inbound + Outbound' : i ? 'Inbound' : o ? 'Outbound' : 'None';
    var q = 'phone=' + encodeURIComponent(phone);
    if (ids.indexOf('sms') > -1) q += '&sms=1';
    if (ids.indexOf('orb') > -1) q += '&orbit=1';
    /* on-site journey parameters (never shown on the page, stored on the order by wb-shell.js) */
    q += '&wb_from=' + (from || 'home') + '&wb_item=' + encodeURIComponent(ids.join('+') || 'none');
    return window.WB_DEST('buy', '/products/ai-phone', q, '#models');
  };
  /* The same product page without a preset choice (generic "Get started" style buttons). */
  window.WB_PRODUCT_HREF = function (from, item) {
    return window.WB_DEST('buy', '/products/ai-phone', 'wb_from=' + (from || 'home') + '&wb_item=' + (item || 'cta'), '#models');
  };
  /* Where a footer label goes. An empty answer hides the entry: the site never shows a link that leads nowhere. */
  window.WB_LINK = function (label) {
    var L = window.WB_LINKS(), here = window.WB_HOME || function (h) { return h; }, live = !!window.WB_SHOP_CONFIG;
    var coll = window.WB_DEST('collection', '/collections/ai-phones');
    /* a store policy opens in the visitor's language: /fr/policies/... on the French site */
    var root = (window.WB_I18N && window.WB_I18N.root) || '';
    var pol = function (u) { u = u || ''; return root && u.indexOf('/policies/') === 0 ? root + u : u; };
    var map = {
      'All AI Phones': coll,
      'AI Phone Inbound': window.WB_BUY_HREF(['in'], 'footer'),
      'AI Phone Outbound': window.WB_BUY_HREF(['out'], 'footer'),
      'SMS Reviews Collector': window.WB_BUY_HREF(['in', 'sms'], 'footer'),
      'Bundle': window.WB_BUY_HREF(['in', 'out', 'sms'], 'footer'),
      'Pricing': window.WB_PRODUCT_HREF('footer', 'pricing'),
      'About WinBoost': L.about || '',
      'Careers': L.careers || '',
      'Contact': L.contact || (live ? '' : here('#final-form')),
      'Partners': L.partners || '',
      'Become an AI Phone Online Retailer': window.WB_URL('pages/become-an-online-retailer'),
      'Become an AI Phone Reseller': L.reseller || '',   /* empty until the page exists: the footer never shows a link that leads nowhere */
      'How it works': here('#how-it-fits'),
      'Hear a call': here('#hear-it'),
      'Integrations': here('#integrations'),
      'FAQ': here('#faq'),
      'AI Phone directory': window.WB_URL('pages/ai-phone-directory'),
      'AI Receptionist directory': window.WB_URL('pages/ai-receptionist-directory'),
      'AI Sales Agent directory': window.WB_URL('pages/ai-sales-agent-directory'),
      'Privacy': pol(L.privacy),
      'Terms': pol(L.terms),
      'Refund policy': pol(L.refund),
      'Shipping policy': pol(L.shipping),
      'Contact information': pol(L.contactinfo),
      'Legal notice': pol(L.legal),
      'Cookie policy': L.cookies || '',
      /* opens the preferences of Shopify's cookie banner; hidden until that banner is switched on (wb-track.js marks the page) */
      'Cookie preferences': live ? '#cookie-preferences' : '',
      /* Google "preferred sources": the visitor adds winboost.ai to the sources Google favors for them (Top Stories, AI Mode) */
      'Prefer WinBoost on Google': 'https://www.google.com/preferences/source?q=winboost.ai',
      'Data processing': L.dpa || ''
    };
    return map[label] || '';
  };
  /* The footer columns: the AI Phones collection joins the Product column, and entries without a destination are hidden. */
  window.WB_FOOTER_COLS = function (cols) {
    return cols.map(function (c) {
      var items = c[1].slice();
      if (c[0] === 'Product' && items.indexOf('All AI Phones') < 0) items.unshift('All AI Phones');
      if (c[0] === 'Company' && items.indexOf('About WinBoost') < 0 && items.indexOf('About') < 0) items.unshift('About WinBoost');
      if (c[0] === 'Company' && items.indexOf('Become an AI Phone Reseller') < 0) items.push('Become an AI Phone Reseller');
      /* Legal: every store policy, the cookie policy and the cookie preferences, before "Data processing" */
      if (c[0] === 'Legal') ['Refund policy', 'Shipping policy', 'Contact information', 'Legal notice', 'Cookie policy', 'Cookie preferences'].forEach(function (l) {
        if (items.indexOf(l) > -1) return;
        var at = items.indexOf('Data processing'); items.splice(at > -1 ? at : items.length, 0, l);
      });
      if (c[0] === 'Resources' && items.indexOf('Prefer WinBoost on Google') < 0) items.push('Prefer WinBoost on Google');
      return [c[0], items.filter(function (l) { return !!window.WB_LINK(l); })];
    }).filter(function (c) { return c[1].length; });
  };
  window.WB_CONFIG = CONFIG;
  window.WB_AGENT_CALL = CONFIG.phone ? 'tel:' + CONFIG.phone.replace(/[^\d+]/g, '') : '';
  window.WB_PHONE_DISPLAY = CONFIG.phone;

  /* Formats a demo line for one industry: {display, href} or null when unconfigured. */
  window.WB_DEMO_LINE = slug => {
    const raw = (CONFIG.demoNumbers && CONFIG.demoNumbers[slug]) || CONFIG.phone || '';
    if (!raw) return null;
    const digits = raw.replace(/[^\d+]/g, '');
    const na = digits.match(/^\+?1?(\d{3})(\d{3})(\d{4})$/);
    return { display: na ? '(' + na[1] + ') ' + na[2] + '-' + na[3] : raw, href: 'tel:' + digits };
  };

  /* Resolves one industry's recorded call to a playable src, or null. */
  window.WB_CALL_RECORDING = slug => {
    const raw = (CONFIG.callRecordings && CONFIG.callRecordings[slug]) || '';
    if (!raw) return null;
    return /^(https?:)?\/\//.test(raw) || raw.indexOf('/') > -1 ? raw : 'assets/calls/' + raw;
  };

  /* Sends a lead through Shopify's own contact form, so it arrives as an email to the store owner
     (reply-to = the visitor). Needs a valid email address, exactly like the store's other forms. */
  const shopifyLead = async body => {
    const rows = [['Source', body.source], ['Name', body.name], ['Business', body.business], ['Phone', body.phone], ['Email', body.email],
      ['Interested in', Array.isArray(body.interestedIn) ? body.interestedIn.join(', ') : body.interestedIn],
      ['Agent type', body.agentType], ['Page', body.page], ['Referrer', body.referrer]];
    const att = window.wbAttribution ? window.wbAttribution() : {};
    Object.keys(att).forEach(k => rows.push(['Tracking ' + k, att[k]]));
    const fields = {
      form_type: 'contact', utf8: '\u2713',
      'contact[name]': body.name || '', 'contact[email]': body.email || '', 'contact[phone]': body.phone || '',
      'contact[body]': 'New lead from the WinBoost website\n\n' + rows.filter(r => r[1]).map(r => r[0] + ': ' + r[1]).join('\n')
    };
    /* Announces the lead as the custom event wb_lead (Customer events / Google Tag Manager). Only the form's origin, never the visitor's name, email or phone. */
    const tracked = () => { try { window.wbTrack && window.wbTrack('lead', { source: body.source, agent_type: body.agentType || '' }); } catch (e) {} };
    try {
      const res = await fetch(window.WB_URL('contact') + '#contact_form', {
        method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(fields).toString()
      });
      if (/\/challenge/.test(res.url)) {
        /* Shopify's spam check wants a human: hand over to the normal browser form post, which shows its check. */
        const f = document.createElement('form');
        f.method = 'post'; f.action = window.WB_URL('contact') + '#contact_form'; f.style.display = 'none';
        Object.keys(fields).forEach(k => { const i = document.createElement('input'); i.type = 'hidden'; i.name = k; i.value = fields[k]; f.appendChild(i); });
        tracked();
        document.body.appendChild(f); f.submit();
        return { ok: true };
      }
      /* A valid post is answered with a redirect; a rejected one (bad email) is answered in place. */
      if (res.redirected) { tracked(); return { ok: true }; }
      return { ok: false, error: 'Rejected' };
    } catch (e) {
      return { ok: false, error: (e && e.message) || 'Network error' };
    }
  };

  /* Posts a lead. Resolves {ok:true} or {ok:false, error}. Never throws. */
  window.wbSubmitLead = async (payload, source) => {
    const body = {
      ...payload,
      source: source || 'website',
      page: location.pathname,
      referrer: document.referrer || null,
      submittedAt: new Date().toISOString()
    };
    if (CONFIG.shopifyLeads) return shopifyLead(body);
    if (!CONFIG.webhook) {
      console.warn('[WinBoost] No webhook configured, lead not sent:', body);
      return { ok: false, error: 'Not configured' };
    }
    try {
      const res = await fetch(CONFIG.webhook, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) return { ok: false, error: 'HTTP ' + res.status };
      return { ok: true };
    } catch (e) {
      return { ok: false, error: (e && e.message) || 'Network error' };
    }
  };
})();
